import {
    Component, HostListener,
    ElementRef, ViewContainerRef, OnInit, Input, Output, EventEmitter
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'underscore';
import { TreeviewItem, TreeviewConfig } from 'ngx-treeview';
import { ResetPasswordPage } from './employeeActions/resetPasswordByAdmin';
import { SharedData } from '../shared/sharedData';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { Auth } from '../shared/services/auth';
import { ToasterComponent } from '../toasterComponent/toasterComponent';

@Component({
    selector: 'employeeFilter',
    templateUrl: 'employeeFilter.html',
})
export class EmployeeFilter implements OnInit {
    public isCollapsed = false
    @Input()
    public displayTab: any;
    @Output() public searchEmp = new EventEmitter();
    public closeResult: any;
    public showButtonLoading: any = false;
    public type = '';
    public programId = '';
    // tree
    public orgData: any = [];
    public showOrg: boolean = false;
    public dropDownEnabled = true;
    public items: TreeviewItem[];
    public values: number[];
    public config = TreeviewConfig.create({
        hasAllCheckBox: true,
        hasFilter: true,
        hasCollapseExpand: true,
        decoupleChildFromParent: false,
        maxHeight: 400
    });
    public buttonClasses = [
        'btn-outline-primary',
        'btn-outline-secondary',
        'btn-outline-success',
        'btn-outline-danger',
        'btn-outline-warning',
        'btn-outline-info',
        'btn-outline-light',
        'btn-outline-dark'
    ];
    public buttonClass = this.buttonClasses[6];
    public empCodeValues: any = '';
    public excludeEmpCodeValues: any = '';
    /// multiSelect
    public itemDesignationList: any = [];
    public itemGradeList: any = [];
    public itemManagerList: any = [];
    public itemCatList: any = [];
    public itemPositionList: any = [];
    public itemPayBasisList: any = [];
    public itemNationalityGroupList: any = [];
    public itemStaffCategoryList: any = [];
    public itemWorkingSpecialtyList: any = [];
    public itemAssignmentStatusTypeList: any = [];
    public itemStatusList: any = [];
    public itemSuperList: any = [];
    public selectedDesignationItems = [];
    public selectedPositions = [];
    public selectedPayBasis = [];
    public selectedNationalityGroup = [];
    public selectedStaffCategory = [];
    public selectedWorkingSpecialty = [];
    public selectedAssignmentStatusType = [];
    public selectedGradeItems = [];
    public selectedManagerItems = [];
    public selectedCatItems = [];
    public selectedStatusItems = [];
    public selectedSuperItems = [];
    public designationSettings = {};
    public gradeSettings = {};
    public managerSettings = {};
    public catSettings = {};
    public positionSettings = {};
    public workingSpecialtySettings = {};
    public assignmentStatusTypeSettings = {};
    public staffCategorySettings = {};
    public nationalityGroupSettings = {};
    public PayBasisSettings = {};
    public statusSettings = {};
    public superSettings = {};

    public page = 5;
    public endingPage = 0;
    public startingPage = 0;
    public localState = { value: '' };
    public _baseUrl: any;
    public employeeData: any = [];
    public employeePageData: any = [];
    public trackHides = null;
    public designationModel: any = {
        id: null,
        name: ''
    };
    public organizationModel: any = {
        id: null,
        orgName: ''
    };
    public orgName: string = '';
    public designationName: String = '';
    public displayName: String = '';
    public primarySupervisorModel: any = {
        id: null,
        displayName: ''
    };

    public statusData: any = '';
    public employeeCode: any;
    public showAdvanceSearch: any = false;
    public pageSize: any = 10;
    public showLoading: any = false;
    public currentPage: any;
    public searchData = {
        nameOrCodeOrEmail: '',
        employeeCodes: [],
        excludedEmployeeCodes: [],
        includeEmpIds: [],
        excludeEmpIds: [],
        gradeIds: [],
        mgrLevelIds: [],
        designationIds: [],
        categoryIds: [],
        includeOrgIds: [],
        excludeOrgIds: [],
        supervisorIds: [],
        primarySupervisorIds: [],
        primarySupervisorNameOrCode: null,
        primarySupervisorCods: [],
        positionIds: [],
        payBasisIds: [],
        nationalityGroupIds: [],
        staffCategoryIds: [],
        workingSpecialtyIds: [],
        entityIds: [],
        employeeStatus: null,
        employeesWithOutSupervisor: null,
        scorecardStates: null,
        memberShipState: null,
        programId: null,
        pageSize: 10,
        page: 1,
        fetchSupervisorLevels: 0,
        licenceNumber: null
    };
    public designationText: string;
    public basicPayText: any;
    public jobGradeText: any;
    public empTypeText: any;
    public jobCatText: any;
    public positionText: any;
    public nationalityText: any;
    public staffCatogoryText: any;
    public workSpecialtyText: any;
    public assignmentStatusText: any;
    public supervisorText: any;
    public selectAllLabel: any;
    public unSelectAllLabel: any;
    public searchDesignation: any;
    public searchPayBasis: any;
    public searchJobGrade: any;
    public searchEmpType: any;
    public searchJobCategory: any;
    public searchPosition: any;
    public searchNationality: any;
    public searchStaffCategory: any;
    public searchWorkSpecialty: any;
    public searchAssignmentStatus: any;
    public searchSupervisor: any;

    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public router: Router,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _auth: Auth,
        public eRef: ElementRef,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public _location: Location,
        public vcr: ViewContainerRef,
        public _translate: TranslateService
    ) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.currentPage = 1;
        this._auth.closeFilterValue.subscribe(() => {
            this.isCollapsed = false;
        });
        this.translateFilterLabels();

    }
    public translateFilterLabels() {
        this._translate.get('seletDesignation').subscribe((res) => {
            this.designationText = res;
        });
        this._translate.get('selectBasicPay').subscribe((res) => {
            this.basicPayText = res;
        });
        this._translate.get('selectJobGrade').subscribe((res) => {
            this.jobGradeText = res;
        });
        this._translate.get('selectEmpType').subscribe((res) => {
            this.empTypeText = res;
        });
        this._translate.get('selectJobCategory').subscribe((res) => {
            this.jobCatText = res;
        })
        this._translate.get('selectPosition').subscribe((res) => {
            this.positionText = res;
        })
        this._translate.get('selectNationality').subscribe((res) => {
            this.nationalityText = res;
        })
        this._translate.get('selectStaffCategory').subscribe((res) => {
            this.staffCatogoryText = res;
        })
        this._translate.get('selectWorkingSpecialty').subscribe((res) => {
            this.workSpecialtyText = res;
        })
        this._translate.get('selectAssignmentStatus').subscribe((res) => {
            this.assignmentStatusText = res;
        })
        this._translate.get('selectSupervisor').subscribe((res) => {
            this.supervisorText = res;
        })
        this._translate.get('selectAll').subscribe((res) => {
            this.selectAllLabel = res;
        })
        this._translate.get('unSelectAll').subscribe((res) => {
            this.unSelectAllLabel = res;
        })
        this._translate.get('searchDesignation').subscribe((res) => {
            this.searchDesignation = res;
        })
        this._translate.get('searchPayBasis').subscribe((res) => {
            this.searchPayBasis = res;
        })
        this._translate.get('searchJobGrade').subscribe((res) => {
            this.searchJobGrade = res;
        })
        this._translate.get('searchEmpType').subscribe((res) => {
            this.searchEmpType = res;
        })

        this._translate.get('searchJobCategory').subscribe((res) => {
            this.searchJobCategory = res;
        })
        this._translate.get('searchPosition').subscribe((res) => {
            this.searchPosition = res;
        })
        this._translate.get('searchNationality').subscribe((res) => {
            this.searchNationality = res;
        })
        this._translate.get('searchWorkSpecialty').subscribe((res) => {
            this.searchWorkSpecialty = res;
        })
        this._translate.get('searchAssignmentStatus').subscribe((res) => {
            this.searchAssignmentStatus = res;
        })
        this._translate.get('searchSupervisor').subscribe((res) => {
            this.searchSupervisor = res;
            //As we need the translated text we are calling defautFilterSettings at last.
            this.defaultFilterSettings();
        })

    }
    public defaultFilterSettings() {
        this.superSettings = {
            text: this.supervisorText,
            selectAllText: this.selectAllLabel,
            unSelectAllText: this.unSelectAllLabel,
            classes: '',
            primaryKey: 'id',
            labelKey: 'displayName',
            noDataLabel: this.searchSupervisor,
            enableSearchFilter: true,
            badgeShowLimit: 3,
            searchBy: ['id', 'displayName']
        };
    }

    public ngOnInit() {
        
    }

    public reset() {
        this.searchData.gradeIds = [];
        this.selectedGradeItems = [];
        this.searchData.mgrLevelIds = [];
        this.selectedManagerItems = [];
        this.searchData.categoryIds = [];
        this.selectedCatItems = [];
        this.searchData.designationIds = [];
        this.selectedDesignationItems = [];
        this.selectedPositions = [];
        this.selectedPayBasis = [];
        this.selectedNationalityGroup = [];
        this.selectedStaffCategory = [];
        this.selectedWorkingSpecialty = [];
        this.selectedAssignmentStatusType = [];
        this.searchData.includeOrgIds = [];
        this.searchData.employeeCodes = [];
        this.empCodeValues = '';
        this.searchData.excludedEmployeeCodes = [];
        this.excludeEmpCodeValues = '';
        this.searchData.positionIds = [];
        this.values = [];
        this.searchData.nameOrCodeOrEmail = '';
        this.searchData.employeeStatus = null;
        this.selectedStatusItems = [
            { id: '', itemName: 'All' }];
        this.searchData.supervisorIds = [];
        this.selectedSuperItems = [];
    }

    public populateData(val) {
        if (this.empCodeValues.trim() !== '') {
            this.searchData.employeeCodes = this.empCodeValues.split(',');
        } else {
            this.searchData.employeeCodes = [];
        }
        if (this.excludeEmpCodeValues.trim() !== '') {
            this.searchData.excludedEmployeeCodes = this.excludeEmpCodeValues.split(',');
        } else {
            this.searchData.excludedEmployeeCodes = [];
        }
        this.searchData.gradeIds = this.getIds(this.selectedGradeItems);
        this.searchData.mgrLevelIds = this.getIds(this.selectedManagerItems);
        this.searchData.categoryIds = this.getIds(this.selectedCatItems);
        this.searchData.designationIds = this.getIds(this.selectedDesignationItems);
        this.searchData.positionIds = this.getIds(this.selectedPositions);
        this.searchData.payBasisIds = this.getIds(this.selectedPayBasis);
        this.searchData.nationalityGroupIds = this.getIds(this.selectedNationalityGroup);
        this.searchData.staffCategoryIds = this.getIds(this.selectedStaffCategory);
        this.searchData.workingSpecialtyIds = this.getIds(this.selectedWorkingSpecialty);
        this.searchData.entityIds = this.getIds(this.selectedAssignmentStatusType);

        this.searchData.employeeStatus = null;
        this.searchData.supervisorIds = this.getIds(this.selectedSuperItems);
        this.searchData.includeOrgIds = [];
        this.searchEmp.emit(this.searchData);
    }

    public getIds(data) {
        let ids = [];
        for (let t of data) {
            ids.push(t.id);
        }
        return ids;
    }

    // Patch for pop-over issue
    @HostListener('window:click', ['$event'])
    public clickOut(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(() => {
                this.trackHides = null;
            }, 100);
        }
    }
    public clicked() {
        this.trackHides = null;
    }

    // show and hide Advance Search option
    public showAdvanced(e) {
        this.showAdvanceSearch = e;
    }

    public searchEmployeeCods(e) {
        if (e === '') {
            this.searchData.employeeCodes = [];
        } else {
            this.searchData.employeeCodes[0] = e;
        }
    }

    // To get list of Organization based on keyword
    public organizationObservableSource = (keyword: any): Observable<any[]> => {
        let url = this._baseUrl + 'v1/webAdmin/employee/orgSearch';
        url += '?searchString=' + keyword;
        if (keyword) {
            return this.http.get(url)
                .map((res) => {
                    return res;
                }, (error) => {
                    return Observable.of([]);
                });
        } else {
            return Observable.of([]);
        }

    }

    // To get list of designation based on keyword
    public designationObservableSource = (keyword: any): Observable<any[]> => {
        let url = this._baseUrl + 'v1/webAdmin/employee/designationSearch';
        url += '?searchString=' + keyword;
        if (keyword) {
            return this.http.get(url)
                .map((res) => {
                    return res;
                }, (error) => {
                    return Observable.of([]);
                });
        } else {
            return Observable.of([]);
        }
    }

    public gotNewValue(e, type) {
        let d: string;
        if (e.id !== undefined) {
            d = (e.id.toString());
        }
        if (type === 'designation') {
            if (this.designationModel === '') {
                this.searchData.designationIds = [];
                return;
            }
            this.searchData.designationIds[0] = d;
        }
        if (type === 'organization') {
            if (this.organizationModel === '') {
                this.searchData.includeOrgIds = [];
                return;
            }
            this.searchData.includeOrgIds[0] = d;
        }
        if (type === 'primary') {
            if (this.primarySupervisorModel === '') {
                this.searchData.supervisorIds = [];
                return;
            }
            this.searchData.supervisorIds[0] = d;
        }
    }

    public empTableActions(value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        } else {
            this.trackHides = value;
        }
    }

    public empTableResetPwd(id) {
        this.trackHides = null;
        this.share.saveData(id);
        const modalRef = this.modalService.open(ResetPasswordPage, { windowClass: 'min-modal' });
    }

    public isSearchToggle() {
        this.isCollapsed = this.isCollapsed ? false : true;
    }

}



// WEBPACK FOOTER //
// ./src/app/employee/employeeFilter.ts